"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _reactDom = require("react-dom");

var _hooks = require("../../hooks");

var _Portal = require("./Portal.utils");

const Portal = _ref => {
  let {
    rootId = 'body',
    rootRef,
    children
  } = _ref;
  const rootElement = (0, _react.useRef)(null);
  const getRootElement = (0, _hooks.useConstCallback)(() => {
    let root = (0, _Portal.getPortalRoot)({
      rootRef,
      rootId
    });

    if (!root) {
      root = document.createElement('div');
      root.id = rootId;
      document.body.appendChild(root);
      rootElement.current = root;
    }

    return root;
  });
  (0, _react.useEffect)(() => {
    const root = rootElement.current;
    return () => {
      if (root && root.parentNode && root !== document.body) {
        root.parentNode.removeChild(root);
      }

      rootElement.current = null;
    };
  }, []);
  return /*#__PURE__*/(0, _reactDom.createPortal)(children, rootElement.current || getRootElement());
};

var _default = Portal;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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